import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import classnames from 'classnames';

import './side-panel-action-button.scss';

export function SidePanelActionButton({
  icon = null,
  label,
  onClick,
  trackingId,
  trackingValue = null,
  buttonClassNames = '',
  iconWidth = 16,
  hoverCopy = null,
}) {
  return (
    <Button
      aria-label={label}
      color="link"
      onClick={onClick}
      className={classnames(
        'side-panel-action-button d-flex align-items-center p-0 bg-blue-40 mb-1 text-decoration-none pos-r rounded-20 overflow-hidden text-nowrap border-0',
        buttonClassNames
      )}
      data-tracking-id={trackingId}
      data-tracking-value={trackingValue}
    >
      <span className="icon-wrap d-flex align-items-center justify-content-center flex-shrink-0">
        <img src={icon} width={iconWidth} alt="" className="text-white" />
      </span>
      {hoverCopy && (
        <span className="hover-copy text-cool-gray-100 fw-medium text-transform-none ms-0_5 pe-0_75 size-14">
          {hoverCopy}
        </span>
      )}
    </Button>
  );
}

SidePanelActionButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  trackingId: PropTypes.string.isRequired,
  icon: PropTypes.string,
  trackingValue: PropTypes.string,
  buttonClassNames: PropTypes.string,
  iconWidth: PropTypes.number,
  hoverCopy: PropTypes.string,
};
